import React from 'react';
import { List } from 'immutable';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import './ListOfFilters.scss';
import PropTypes from 'prop-types';
import FiltersByType from '../FiltersByType';

const spinnerId = 'ListOfFilters-spinner';

function ListOfFilters(props) {
  const { toggleFilter, filters, keyifyParamsForFiltersRequest, paramsForFiltersRequest } = props;
  const { context } = paramsForFiltersRequest;
  if (!filters) {
    return <RxSpinnerComponent autoStart spinnerId={spinnerId} />;
  }
  return (
    <div className="list-of-filters">
      <ul className="list-of-filters-wrapper">
        {filters.map((filter) => {
          const id = filter.get('id');
          const isControlsDisabled = id === 'PROD.TIER';
          return (
            <FiltersByType
              key={id}
              keyifyParamsForFiltersRequest={keyifyParamsForFiltersRequest}
              context={context}
              filter={filter}
              toggleFilter={toggleFilter}
              disableControls={isControlsDisabled}
            />
          );
        })}
      </ul>
    </div>
  );
}

ListOfFilters.propTypes = {
  filters: PropTypes.instanceOf(List),
  toggleFilter: PropTypes.func.isRequired,
  keyifyParamsForFiltersRequest: PropTypes.string.isRequired,
  paramsForFiltersRequest: PropTypes.object.isRequired,
};

export default ListOfFilters;
